import { BuybackSettings } from "@/apps/shared/buyback/core/domain/model/settings/BuybackSettings";
import { RawBuybackSettings } from "@/apps/shared/buyback/core/infrastructure/repository/type/RawBuybackSettings";

class BuybackSettingsMapper {
  mapBuybackSettingsFromResponse(responseDataFromApi: RawBuybackSettings): BuybackSettings {
    return new BuybackSettings(
      responseDataFromApi.customer_identity_document_required,
      responseDataFromApi.cart_min_value
    );
  }
}

export default new BuybackSettingsMapper();
